import { DateTime } from '@cheqroom/date-time';

import { Plan as PlanGroupkey } from '../features';
import type { User } from './types';

/**
 * Resolves the current user from the legacy Knockout/global state (window.global.central).
 * Used when authentication userSource is 'knockout'. Assumes central.user(), contact(), subscription(), profile(), and group are available.
 */
export function resolveUserFromKnockout(organisationId = ''): User {
	const knockoutUser = window.global?.central?.user?.() || {};
	const knockoutContact = window.global?.central?.contact?.() || {};
	const subscription = window.global?.central?.subscription?.() || {};
	const weekStart = window.global?.central?.profile?.()?.weekStart;

	return {
		email: knockoutUser.email,
		id: knockoutUser._id,
		name: knockoutUser.name,
		picture: knockoutUser.picture_url,
		roleId: knockoutUser.role,
		timezone: knockoutUser.timezone,
		username: knockoutUser.login,
		sync: knockoutUser.sync ?? null,
		ssoOnly: knockoutUser.ssoOnly ?? false,
		syncName: knockoutUser.syncName ?? null,
		organisationId,
		workspace: {
			id: window.global.central.group.id,
			name: window.global.central.group.name,
			tags: window.global.central.group?.raw?.tags ?? [],
			isInBetaProgram: window.global.central.group?.raw?.isInBetaProgram ?? false,
			signedUpAt: window.global.central.group?.raw?.signedup
				? DateTime.fromDate(
						typeof window.global.central.group?.raw?.signedup === 'string'
							? new Date(window.global.central.group?.raw?.signedup)
							: window.global.central.group?.raw?.signedup.toDate()
					)
				: null,
		},
		subscription: {
			planId: subscription.subscriptionPlan._id,
			kind: subscription.kind,
			status: subscription.status,
			plan: {
				family: subscription.subscriptionPlan.family,
				groupKey: subscription.subscriptionPlan.groupKey as PlanGroupkey,
			},
		},
		preferences: {
			firstDayOfWeek: weekStart === 1 ? 'monday' : 'sunday',
		},
		contactId: knockoutContact._id,
		publicKey: knockoutUser.publicKey,
		customerId: knockoutUser.customer._id,
		customer: {
			_id: knockoutUser.customer._id,
			contactGroups: knockoutUser.customer.contactGroups,
		},
		profile: {
			viewSupportChat: knockoutUser.profile?.viewSupportChat ?? false,
		},
	};
}
